import React from 'react'
import AppContext from './appContext'
import { useEffect, useState, useRef } from 'react'
import useLocalStorage from '../hooks/useLocalStorage'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
const AppState = (props) => {


    // console.clear()
    const history = useHistory()

    const [authToken, setAuthToken] = useLocalStorage("auth-token", null);
    const [adminToken, setAdminToken] = useLocalStorage("admin-token", null);

    const [mainLoader, setMainLoader] = useState(false)
    console.log("helloworld");

    const [signUpError, setSignUpError] = useState(null)


    const createAccount = async (referralUser, referralID, walletAddress, fullName, phoneNumber, name, email, password, amount, initialLevel) => {

        // settheProductLoader(true)
        setMainLoader(true)
        const url = `https://vertex-chain-backebd-ivory.vercel.app/api/auth/createuser/${referralID}`
        const response = await fetch(url, {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "Accept": "*",
            },

            body: JSON.stringify({ walletAddress, fullName, phoneNumber, name, email, password, amount, initialLevel }), // body data type must match "Content-Type" header
        });
        console.log(response);
        
        if (!response.ok) {
            if(response.status==500) setSignUpError("Please fill all the required fields")
            if(response.status==400) setSignUpError("A User with this email or connected wallet address already exists")
            setMainLoader(false)
        }
        else {
            const data = await response.json(); // parses JSON response into native JavaScript objects
            if (data.authToken) setAuthToken(data.authToken)
            
            if (data.authToken) {
                setMainLoader(true)
                creationEmail(walletAddress, fullName, phoneNumber, email, name, initialLevel)
                if (referralUser) {
                    const referralCurrentState = await getUserfromAddress(referralUser.walletAddress)
                    if (referralCurrentState.level !== referralUser.level) {
                        const { walletAddress, fullName, phoneNumber, email, name, level, referrals } = referralCurrentState
                        levelUpEmail(walletAddress, fullName, phoneNumber, email, name, level, referrals.length)
                    }
                }

            }
            else (
                setMainLoader(false)
            )
        }
        // console.log(data.name);



        // console.log(data.map((e)=>{return e.id}))

    }
    const [userData, setUserData] = useState(null)
    const getUser = async (connectedaddress) => {

        setMainLoader(true)
        // settheProductLoader(true)

        const url = `https://vertex-chain-backebd-ivory.vercel.app/api/auth/getuser`
        const response = await fetch(url, {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "Accept": "*",
                "auth-token": authToken
            },

            // body: JSON.stringify({ walletAddress,fullName,phoneNumber,name,email,password,amount,initialLevel }), // body data type must match "Content-Type" header
        });
        const data = await response.json(); // parses JSON response into native JavaScript objects
        console.log(data);

        setUserData(data)

        // console.log(data.name);


        setMainLoader(false)
        // console.log(data.map((e)=>{return e.id}))

    }
    const [allUsers, setallUsers] = useState([])
    const getUsers = async () => {

        // settheProductLoader(true)

        setMainLoader(true)

        const url = `https://vertex-chain-backebd-ivory.vercel.app/api/auth/getusers`
        const response = await fetch(url, {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "Accept": "*"
            },

            // body: JSON.stringify({ walletAddress,fullName,phoneNumber,name,email,password,amount,initialLevel }), // body data type must match "Content-Type" header
        });
        const data = await response.json(); // parses JSON response into native JavaScript objects
        setallUsers(data)
        setMainLoader(false)
        console.log(data);


        // setUserData(data)
        // console.log(data.name);



        // console.log(data.map((e)=>{return e.id}))

    }


    console.log('the authtoken: ', authToken)

    const transferRef = useRef(null)

    const transferAmount = async (transferInfo) => {

        // settheProductLoader(true)

        setMainLoader(true)
        transferRef.current.click()

        const url = `https://vertex-chain-backebd-ivory.vercel.app/api/utility/transfer/${transferInfo.to}/${transferInfo.amount}`
        const response = await fetch(url, {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "Accept": "*",
                "auth-token": authToken
            },

            // body: JSON.stringify({ username, password }), // body data type must match "Content-Type" header
        });

        // console.log(response);

        const data = await response.json(); // parses JSON response into native JavaScript objects
        getUser()
        console.log(data);


        // console.log(data.map((e)=>{return e.id}))

    }

    const withdrawRef = useRef(null)
    const withdrawlAmount = async (amount) => {

        // settheProductLoader(true)
        setMainLoader(true)
        withdrawRef.current.click()
        const url = `https://vertex-chain-backebd-ivory.vercel.app/api/utility/withdrawl/${amount}`
        const response = await fetch(url, {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "Accept": "*",
                "auth-token": authToken
            },

            // body: JSON.stringify({ username, password }), // body data type must match "Content-Type" header
        });

        // console.log(response);

        const data = await response.json(); // parses JSON response into native JavaScript objects
        getUser()
        console.log(data);
        confirmWithdrawEmail(amount)


        // console.log(data.map((e)=>{return e.id}))

    }
    const confirmWithdraw = async (userID, withdrawID) => {

        // settheProductLoader(true)
        setMainLoader(true)
        const url = `https://vertex-chain-backebd-ivory.vercel.app/api/utility/confirmWithdraw/${userID}/${withdrawID}`
        const response = await fetch(url, {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "Accept": "*"
            },

            // body: JSON.stringify({ username, password }), // body data type must match "Content-Type" header
        });

        // console.log(response);

        const data = await response.json(); // parses JSON response into native JavaScript objects
        getUsers()
        console.log(data);


        // console.log(data.map((e)=>{return e.id}))

    }
    const confirmWithdrawEmail = async (amount) => {

        // settheProductLoader(true)
      
        const url = `https://vertex-chain-backebd-ivory.vercel.app/api/email/withdrawrequest`
        const response = await fetch(url, {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "Accept": "*"
            },

            body: JSON.stringify({ walletAddress:userData.walletAddress,fullName:userData.fullName,phoneNumber:userData.phoneNumber,email:userData.email,name:userData.name,level:userData.level,amount:amount }), // body data type must match "Content-Type" header
        });

        // console.log(response);

        const data = await response.json(); // parses JSON response into native JavaScript objects
        
        console.log(data);


        // console.log(data.map((e)=>{return e.id}))

    }
    const creationEmail = async (walletAddress,fullName,phoneNumber,email,name,level) => {

        // settheProductLoader(true)
      
        const url = `https://vertex-chain-backebd-ivory.vercel.app/api/email/`
        const response = await fetch(url, {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "Accept": "*"
            },

            body: JSON.stringify({ walletAddress:walletAddress,fullName:fullName,phoneNumber:phoneNumber,email:email,name:name,level:level }), // body data type must match "Content-Type" header
        });

        // console.log(response);

        const data = await response.json(); // parses JSON response into native JavaScript objects
        
        console.log(data);


        // console.log(data.map((e)=>{return e.id}))

    }
    const levelUpEmail = async (walletAddress,fullName,phoneNumber,email,name,level,totalReferrals) => {

        // settheProductLoader(true)
      
        const url = `https://vertex-chain-backebd-ivory.vercel.app/api/email/levelup`
        const response = await fetch(url, {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "Accept": "*"
            },

            body: JSON.stringify({ walletAddress:walletAddress,fullName:fullName,phoneNumber:phoneNumber,email:email,name:name,level:level,totalReferrals:totalReferrals }), // body data type must match "Content-Type" header
        });

        // console.log(response);

        const data = await response.json(); // parses JSON response into native JavaScript objects
        
        console.log(data);


        // console.log(data.map((e)=>{return e.id}))

    }


    const getUserfromAddress = async (walletAddress) => {

        // settheProductLoader(true)

        const url = `https://vertex-chain-backebd-ivory.vercel.app/api/auth/getuserfromwallet/${walletAddress}`
        const response = await fetch(url, {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "Accept": "*",
            },

            // body: JSON.stringify({ username, password }), // body data type must match "Content-Type" header
        });

        // console.log(response);

        const data = await response.json(); // parses JSON response into native JavaScript objects
        return data


        // console.log(data.map((e)=>{return e.id}))

    }



    console.clear()

    return (
        <AppContext.Provider value={{ withdrawRef,transferRef,setSignUpError,signUpError,setUserData, mainLoader, setMainLoader, confirmWithdraw, withdrawlAmount, transferAmount, authToken, createAccount, setAuthToken, getUser, userData, getUsers, allUsers, adminToken, setAdminToken }}>
            {props.children}
        </AppContext.Provider>
    )
}


export default AppState